<div class="location-slider">
  <input type="file" accept="image/*," [disabled]="disabled" multiple hidden #fileUpload (change)="onFileSelected($event)">

  <div class="location-slider__area" *ngIf="!slides.length && !(isLoadingSlides$ | async)">
    <input type="file" accept="image/*," [disabled]="disabled" class="location-slider__file-input" multiple (change)="onFileSelected($event)">
  </div>

  <div class="location-slider__carousel-wrap" [hidden]="!slides.length || (isLoadingSlides$ | async)">
    <ngx-slick-carousel class="location-slider__carousel"
                        #slickModal="slick-carousel"
                        (init)="slickInit($event)"
                        (afterChange)="afterSlideChange($event)"
                        [config]="sliderConfig">
      <div ngxSlickItem class="location-slider__item" *ngFor="let slide of slides">
      <button type="button" *ngIf="!disableAddingRemoving" class="location-slider__delete" [disabled]="disabled" (click)="onDeleteSlide(slide.id);$event.stopPropagation()">
        <img src="assets/images/delete-icon.svg" alt="">
      </button>
        <img [src]="slide.thumbnail" class="location-slider__thumb" alt="">
      </div>
    </ngx-slick-carousel>
    <button type="button" *ngIf="currentSlide !== 1" (click)="slickModal.slickPrev()" class="location-slider__buttons location-slider__buttons--prev">
      <img src="assets/images/icons/vector-left.svg" alt="">
    </button>
    <button type="button" *ngIf="currentSlide !== slides.length" (click)="slickModal.slickNext()" class="location-slider__buttons location-slider__buttons--next">
      <img src="assets/images/icons/vector-right.svg" alt="">
    </button>
  </div>

  <div class="location-slider__spinner" *ngIf="(isLoadingSlides$ | async)">
    <mat-spinner></mat-spinner>
  </div>

  <button *ngIf="!(isLoadingSlides$ | async) && !disableAddingRemoving" type="button" class="dw-btn dw-btn--with-icon add"
          [disabled]="disabled || (isLoadingSlides$ | async)" (click)="onClick(fileUpload)">
    <img src="assets/images/icon_plus.svg" alt="">
    Add photos
  </button>
</div>
